export default __webpack_public_path__ + "static/media/youtube.7a34fdf5.svg";